import React from 'react';
import { ProductState } from '@api/WalletClient';
import { cn } from '@core/utils/cn';
import { Tooltip } from '../../components/tooltip';

interface StateCellProps {
    internalState?: ProductState;
    externalState?: ProductState;
    shopState?: ProductState;
}

function stateColor(state: ProductState | undefined) {
    switch (state) {
        case ProductState.PRODUCTION:
            return 'text-success';
        case ProductState.DISABLED:
            return 'text-destructive';
        default:
            return 'text-muted-foreground';
    }
}

const StateRow = ({
    label,
    tooltip,
    value,
    className
}: {
    label: string;
    tooltip: string;
    value?: string;
    className?: string;
}) => (
    <div className="flex items-center gap-1.5">
        <Tooltip title={tooltip} hideIcon>
            <span className="text-[0.65rem] text-muted-foreground">
                {label}
            </span>
        </Tooltip>
        <span className={cn('text-[0.7rem]', className)}>{value}</span>
    </div>
);

export const StateCell = ({
    internalState,
    externalState,
    shopState
}: StateCellProps) => (
    <div className="flex flex-col gap-1">
        <StateRow
            label="Internal"
            tooltip="Admin controlled state"
            value={internalState || 'N/A'}
            className={stateColor(internalState)}
        />
        <StateRow
            label="External"
            tooltip="Read-only state from vendor source"
            value={externalState || 'N/A'}
            className={stateColor(externalState)}
        />
        <div className="mt-1 border-t pt-1 opacity-60">
            <StateRow
                label="Shop"
                tooltip="Final calculated state. PRODUCTION only when BOTH states are PRODUCTION"
                value={shopState}
                className="text-muted-foreground italic"
            />
        </div>
    </div>
);
